<template>
	<div id="modal-wrapper">
		<modal-component ref="modal" @onModalClose="onModalClose()">
			<div id="new-order-modal" class="modal-container">
				<div class="modal-header">
					{{ isEdit ? 'Edit table number' : 'Start new order'}}
				</div>
				<div class="content">
					<label>
						Table
						<input type="number" v-model="tableNumber" placeholder="Table number" @keyup="onKeyUp"/>
					</label>
					<div class="seat-wrapper ">
						<div class="text seat-text bold">Seat:</div>
						<div class="changer">
							<button @click="changeSeatNumber('decrease')">
								<icon-component iconName="minusBig"/>
							</button>
							<!--<input type="number" v-model="seat" step="1" min="1" max="100" id="age"/>-->
							<span>{{seat}}</span>
							<button @click="changeSeatNumber('increase')">
								<icon-component iconName="plusBig"/>
							</button>
						</div>
					</div>
					<keypad :dot="false" @clickOnKey="keypadClick" @clear="keypadClear"></keypad>
				</div>
				<div :class="['modal-controls', !scannedUser ? 'x3' : 'x2']">
					<base-button text="CANCEL" classes="def-btn cancel-action-btn uppercase medium border-2" @onClick="closeModal"/>
					<base-button v-if="!scannedUser" text="Skip" classes="def-btn secondary-action-btn uppercase medium border-2" @onClick="(!usersModalRef) ? createOrder(true) : null"/>
					<base-button :text="isEdit ? 'Save changes' : 'Create Order'" :isDisabled="!tableNumber" classes="def-btn main-action-btn uppercase medium border-2" @onClick="(!usersModalRef) ? createOrder(false, scannedUser ? scannedUser : false) : null"/>
				</div>
			</div>
		</modal-component>
		<confirmation-modal-component
			ref="confirmation-modal"
			:has-cancel-btn="false"
		/>
		<users-modal
			v-if="usersModalRef"
			ref="usersModalRef"
			:new-order-creation="true"
			@addPayer="setPayer"
			@onModalClose="onUsersModalClose('usersModalRef')"
		/>
	</div>
</template>

<script>
import ModalComponent from "@/components/_shared/Modal";
import Keypad from "@/components/_shared/Keypad";
import ConfirmationModalComponent from "@/components/_shared/ConfirmationModal";
import {orderService} from "@/_api/order.api";
import UsersModal from "@/components/_modals/UsersModal";
import BaseButton from "@/components/_shared/Button.vue";
import iconComponent from "@/components/_shared/Icon.vue";

export default {
	name: 'NewOrderModalComponent',
	emits: ['onTableSetup', 'onModalClose', 'changeOrderTable', 'addTempOrder'],
	props: {
		isEdit: {
			default: false,
			required: false
		},
		setPayerAfter: {
			default: 0,
			required: false,
			type: Number
		},
		noBusinessLogic: {
			default: false,
			required: false,
			type: Boolean
		},
		barcodeScannerFlow: {
			default: false,
			required: false,
			type: Boolean
		},
		selectedOrder: {
			required: false,
			type: Object
		}
    },
	components: {
		ConfirmationModalComponent,
		Keypad,
		ModalComponent,
		UsersModal,
		BaseButton,
		iconComponent
	},
	data() {
		return {
			tableNumber: '',
            allTables:null,
			seat: 1,
			usersModalRef: false,
			scannedUser: null
		}
	},
	computed: {
		design() {
			return this.$store.state.UI
		},
		getPosData: function () {
			return this.$store.state.auth.posData
		}
	},
	created() {},
	mounted() {
		this.emmiter.on('closeModal', () => {
			if (this.$refs['modal']) {
				this.$refs['modal'].close()
			}
		});
	},
	beforeUnmount() {
		this.emmiter.off('closeModal');
		this.emmiter.emit('toggleModals', {opened: false, type: 'NewOrderModal'});
	},
	methods: {
		openModal(data, scannedUser) {
			if (this.isEdit) {
				this.tableNumber = data.table ? data.table.toString() : '';
				this.seat = data.seat ? data.seat : 1;
				this.$forceUpdate();
			}
			if (scannedUser) {
				this.scannedUser = scannedUser;
			}
			this.emmiter.emit('toggleModals', {opened: true, type: 'NewOrderModal'});
			
			this.$refs['modal'].show()
		},
		changeSeatNumber(type) {
			if (type === 'decrease') {
				this.seat > 1 ? this.seat -= 1 : null
			} else {
				this.seat += 1;
			}
		},
		onKeyUp(e, keypad) {
			let q = keypad ? parseInt(e) : parseInt(e.target.value);
			if ((q === 0) && this.tableNumber.toString().length === 1) {
				this.tableNumber = '';
			}
		},
		onModalClose() {
			this.tableNumber = '';
			this.scannedUser = null;
			this.$emit('onModalClose');
			this.emmiter.emit('toggleModals', {opened: false, type: 'NewOrderModal'});
		},
		onUsersModalClose(ref) {
			this[ref] = false;
		},
		closeModal() {
			this.$refs['modal'].close()
		},
		openConfirmationModal() {
			this.$refs['confirmation-modal'].show({
				message: `Table number ${this.tableNumber} is already in use`,
				okButton: 'OK'
			})
		},
        openConfirmationModalNotTable() {
            this.$refs['confirmation-modal'].show({
                message: `There are only ${this.allTables.length} tables`,
                okButton: 'OK'
            })
        },
		setPayer(data) {
			this.createOrder(false, data);
			this.$refs['usersModalRef'].close();
		},
        createOrder(skip, payer_data) {
	        let guestRequired = this.scannedUser ? false : this.getPosData.department.flow_ordering_guest;
			if (this.noBusinessLogic) {
				this.$emit('onTableSetup', {
					table: skip ? '' : this.tableNumber,
					seat: skip ? null : this.seat
				});
				this.$refs['modal'].close();
			} else {
				if (this.isEdit) {
					/*this.emmiter.emit('changeOrderTable', {
						table: skip ? '' : this.tableNumber,
						seat: skip ? null : this.seat
					});*/
					this.$emit('changeOrderTable', {
						table: skip ? '' : this.tableNumber,
						seat: skip ? null : this.seat
					})
					
				} else {
					orderService.getOccupiedTables().then((res) => {
						let tempOrders = JSON.parse(localStorage.getItem('tempOrders'));
						if (res.includes(parseInt(this.tableNumber)) || (tempOrders && tempOrders.findIndex((o) => {return o.table === this.tableNumber}) !== -1)) {
							this.openConfirmationModal()
						} else {
							if (guestRequired && !payer_data) {
								this.usersModalRef = true;
								this.$nextTick(() => {
									this.$refs['usersModalRef'].openModal({
										modalTitleText: 'Set the payer',
										modalSubmitBtnText: 'OK'
									});
								})
							} else {
								this.$emit('addTempOrder', {
									table: skip ? '' : this.tableNumber,
									seat: skip ? null : this.seat,
									payers: payer_data ? payer_data : null
								})
								this.$refs['modal'].close();
							}
						}
					}).catch((err) => {})
				}
			}
        },
		keypadClick(e) {
			this.tableNumber += e.toString();
			this.onKeyUp(e, true)
		},
		keypadClear() {
			this.tableNumber = this.tableNumber.slice(0, -1)
		}
	},
	watch: {}
}
</script>

<style lang="less" scoped>
#modal-wrapper {
	#new-order-modal {
		width: 500px;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		align-items: center;
		box-sizing: border-box;
	}
	label {
		width: 100%;
		margin-bottom: 20px;
		text-align: left;
		font-weight: 600;
		font-size: 14px;
		color: #1C282D;
		justify-content: flex-start;
		display: flex;
		flex-wrap: wrap;
		input {
			width: 100%;
			box-sizing: border-box;
			border: none;
			// border-bottom: 2px solid var(--theme_color);
			font-size: 18px;
			padding: 10px;
			color: #1C282D;
			-moz-appearance:textfield; /* Firefox */
			&::-webkit-inner-spin-button, &::-webkit-outer-spin-button {
				/* display: none; <- Crashes Chrome on hover */
				-webkit-appearance: none;
				margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
			}
		}
	}
	.seat-wrapper {
		margin: 0 auto 20px 0;
		.text {
			width: 100%;
			margin-bottom: 10px;
			text-align: left;
			font-weight: 600;
			font-size: 14px;
			color: #1C282D;
		}
		button {
			border: none;
			background: white;
			cursor: pointer;
		}
		.changer {
			display: flex;
			align-items: center;
			span {
				margin: 0 20px;
			}
		}
	}
	:deep(.keypad) {
		border: none;
		background: none;
		margin: 0 auto;
		.flex-row {
			padding: 0;
		}
	}
	:deep(#confirmation-modal) {
		.window {
			width: 455px;
			.message {
				// color: @theme_color;
				font-size: 42px;
				text-align: center;
				font-weight: 400;
			}
			.btns {
				justify-content: center;
				.main-action-btn {
					width: 180px;
				}
			}
		}
	}
}

</style>
